export default class HeaderMobile { // singleton pattern

    #menuOpen = false;
    #menuElement;
    #buttonElement;
    #buttonSelector;
    #menuSelector;
    #transformClosed = 'translateX(-900px)'
    #transformOpened = 'translateX(0)'

    constructor(
        buttonSelector = "#navbar-toggler",
        menuSelector = "#tf-navbarTogglerMobile",
    ) {
        if (HeaderMobile.singleton) {
            return HeaderMobile.singleton
        }

        this.#buttonSelector = buttonSelector
        this.#menuSelector = menuSelector

        HeaderMobile.singleton = this
        return HeaderMobile.singleton
        
    }

    get menuOpen() {
        return this.#menuOpen
    }
    get menuElement() {
        return this.#menuElement
    }
    get buttonElement() {
        return this.#buttonElement
    }
    get buttonSelector() {
        return this.#buttonSelector
    }
    get menuSelector() {
        return this.#menuSelector
    }

    openMenu() {
        this.#menuElement.style.transform = this.#transformOpened
        this.#menuOpen = true
    }

    closeMenu() {
        this.#menuElement.style.transform = this.#transformClosed
        this.#menuOpen = false
        this.collapseAllCollapsibles()
    }

    toggleMenu() {
        if (this.#menuOpen) {
            this.closeMenu()
        } else {
            this.openMenu()
        }
    }

    collapseAllCollapsibles() {
        if (!window.headerCollapsibles) throw new Error('window.headerCollapsibles must be an array with Collapsible class instances of the header')
        window.headerCollapsibles.forEach(collapsible=>{
            collapsible.collapse()
        })
    }

    setButtonListener() {
        this.#buttonElement.addEventListener("click", ()=>{
            this.toggleMenu()
        })
    }

    setEventListeners() {
        this.setButtonListener()
        this.#buttonElement.addEventListener("click", e=>e.stopPropagation())
        this.#menuElement.addEventListener("click", e=>e.stopPropagation())
        window.addEventListener("click", ()=>{
            if (this.#menuOpen) this.closeMenu()
        })
    }

    init() {
        this.#buttonElement = document.querySelector(this.#buttonSelector)
        this.#menuElement = document.querySelector(this.#menuSelector)
        if(this.#buttonElement && this.#menuElement) {
            this.setEventListeners()
            this.#menuElement.style.transform = this.#transformClosed
        }
    }

}